import { TimerPauseIcon } from './TimerPauseIcon';

/**
 * author: Colton Wiscombe
 * id 3BF45E47-3FE7-43FE-AE4B-FFD605289C60
 * name timer-pause
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-pause.svg
 * tags
 * - Date / Time 
 */
export const StopwatchPauseIcon = TimerPauseIcon;
export default StopwatchPauseIcon